module.exports = __webpack_public_path__ + "img/logo_footer.db394aa.svg";